import React from "react";
import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { MANIFESTO, ASSETS } from "../data";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-40 overflow-hidden"
    >
      <div className="absolute -left-40 top-20 w-[520px] h-[520px] rounded-full bg-[#003399]/15 blur-[140px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section header */}
        <div className="grid md:grid-cols-12 gap-8 items-end mb-20">
          <div className="md:col-span-8">
            <Reveal>
              <p className="text-[#003399] font-bold text-xs uppercase tracking-[0.3em] mb-6">
                The Manifesto
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-display text-4xl md:text-6xl uppercase leading-[1.05] text-[#F2F2F2]">
                A lantern for the
                <br />
                <span className="text-outline">island's sound</span>
              </h2>
            </Reveal>
          </div>
          <div className="md:col-span-4">
            <Reveal delay={0.2}>
              <p className="text-[#F2F2F2]/70 font-light leading-relaxed border-l border-[#003399] pl-6">
                TAO LUMIN is a dynamic DJ and producer raised in Nassau, The
                Bahamas — playing the full spectrum of house and turning every
                set into a journey of music, culture and connection.
              </p>
            </Reveal>
          </div>
        </div>

        {/* Chapters */}
        <div className="grid md:grid-cols-2 gap-x-16 gap-y-16">
          {MANIFESTO.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.08}>
              <div className="group relative border-t border-white/10 pt-8">
                <div className="flex items-start gap-6">
                  <span className="font-display text-5xl md:text-6xl text-outline-blue leading-none shrink-0 transition-all duration-500 group-hover:[-webkit-text-stroke:1.5px_#003399]">
                    {c.num}
                  </span>
                  <div>
                    <h3 className="font-display text-xl md:text-2xl uppercase text-[#F2F2F2] mb-3">
                      {c.title}
                    </h3>
                    <p className="text-[#F2F2F2]/65 font-light leading-relaxed text-sm md:text-base">
                      {c.body}
                    </p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Signature image strip */}
        <Reveal delay={0.1} className="mt-24">
          <div className="relative overflow-hidden h-[320px] md:h-[460px]">
            <motion.img
              src={ASSETS.headshot}
              alt="TAO LUMIN performing by the water in Nassau"
              initial={{ scale: 1.15 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
              className="w-full h-full object-cover object-[center_25%]"
            />
            <div className="absolute inset-0 bg-[#003399]/25 mix-blend-multiply" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
            <div className="absolute bottom-6 left-6 md:bottom-10 md:left-10">
              <p className="font-display text-2xl md:text-4xl uppercase text-[#F2F2F2]">
                Lounge · Funk · High Energy
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default About;
